import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded';

(function initMasonry () {
  // relayout Masonry after all images have loaded
  const grid = document.querySelector('.grid')

  const gridSettingsElement = document.querySelector('[data-masonry]')
  const gridSettingsDict = JSON.parse(gridSettingsElement.dataset.masonry)
  const { columnWidth } = gridSettingsDict
  const { itemSelector } = gridSettingsDict

  imagesLoaded(grid, () => {
    new Masonry(grid, { columnWidth, itemSelector })
  })
}())
